import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES, APP_CONFIG } from '../../constants';
import { Home, BarChart3, ArrowRight, Mail } from 'lucide-react';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <div className="w-24 h-24 bg-destructive-background rounded-full flex items-center justify-center mx-auto mb-6">
            <span className="text-6xl font-bold text-destructive">!</span>
          </div>
          <h1 className="text-6xl font-bold text-foreground mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-foreground mb-2">
            Page Not Found
          </h2>
          <p className="text-muted-foreground mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        <div className="space-y-4 mb-8">
          <Link
            to={ROUTES.HOME}
            className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary-hover transition-colors"
          >
            <Home className="w-5 h-5" />
            Go Home
            <ArrowRight className="w-4 h-4" />
          </Link>

          <Link
            to={ROUTES.DASHBOARD}
            className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-card text-foreground border border-border rounded-lg hover:bg-muted transition-colors"
          >
            <BarChart3 className="w-5 h-5" />
            Go to Dashboard
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="bg-primary-background rounded-lg p-4">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
              <Mail className="w-4 h-4 text-primary-foreground" />
            </div>
            <p className="text-sm font-medium text-foreground">Need help?</p>
          </div>
          <p className="text-sm text-muted-foreground">
            Return to {APP_CONFIG.NAME} and continue your email marketing
            journey.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
